import React, { useState, useEffect } from 'react'
import { ActionIcon, Box, Button, Group, NumberInput, Paper, Select, SimpleGrid } from '@mantine/core'
import { useSelector } from 'react-redux'
import { IconTrash } from '@tabler/icons-react'

const fieldError = {
  unit_name: '',
  quantity: '',
  price: '',
  length: '',
  width: '',
  height: '',
  weight: '',
}
const defaultError = [
  {...fieldError},
  {...fieldError},
  {...fieldError},
]

const FormBundlePrice = ({ detail, loading, onCloseForm, onSave }) => {
  const { prices, summary } = useSelector(state => state.product_detail)

  const [listBundlePrices, setListBundlePrices] = useState([])
  const [listDeletedBundlePrices, setListDeletedBundlePrices] = useState([])
  const [errorValidation, setErrorValidation] = useState(defaultError)

  const handleRemovePrice = (index) => {
    const data = [...listBundlePrices]
    if (data[index].action === 'update') {
      const _itemDelete = {
        type: data[index].type,
        id: data[index].id,
        action: 'delete',
      }
      setListDeletedBundlePrices((oldval) => [...oldval, _itemDelete])
      data.splice(index, 1)
    } else {
      data.splice(index, 1)
    }
    setListBundlePrices(data)
  }

  const handleChange = (index, key, value) => {
    let data = JSON.parse(JSON.stringify(listBundlePrices))
    data[index][key] = value
    setListBundlePrices(data)
  }

  const handleChangeDimensions = (index, indexDimension, value) => {
    let data = JSON.parse(JSON.stringify(listBundlePrices))
    data[index].dimensions[indexDimension].value = value
    setListBundlePrices(data)
  }

  const handleAddPrice = () => {
    const newData = {
      type: 'bulk_price',
      dimension_unit: summary.dimensionUnit,
      dimensions: [
        {
          label: 'length',
          value: 0,
        },
        {
          label: 'width',
          value: 0,
        },
        {
          label: 'height',
          value: 0,
        },
      ],
      price: 0,
      quantity: 0,
      unit_name: 'crt',
      weight: 0,
      weight_unit: summary.weightUnit,
      action: 'create',
    }

    const data = [...listBundlePrices, newData]
    setListBundlePrices(data)
  }

  const checkValidation = () => {
    let isPass = true
    const _validation = JSON.parse(JSON.stringify(defaultError))

    listBundlePrices.forEach((dataBundlePrice, index) => {
      if (dataBundlePrice.unit_name === '') {
        _validation[index].unit_name = "Unit Name Can't be Empty"
        isPass = false
      }
      if (+dataBundlePrice.quantity === 0) {
        _validation[index].quantity = "Quantity Can't be Empty"
        isPass = false
      }
      if (+dataBundlePrice.price === 0) {
        _validation[index].price = "Price Can't be Empty"
        isPass = false
      }
      // validation length
      if (+dataBundlePrice.dimensions[0].value === 0) {
        _validation[index].length = "Length Can't be Empty"
        isPass = false
      }
      // validation width
      if (+dataBundlePrice.dimensions[1].value === 0) {
        _validation[index].width = "Width Can't be Empty"
        isPass = false
      }
      // validation height
      if (+dataBundlePrice.dimensions[2].value === 0) {
        _validation[index].height = "Height Can't be Empty"
        isPass = false
      }
      if (+dataBundlePrice.weight === 0) {
        _validation[index].weight = "Weight Can't be Empty"
        isPass = false
      }
    })
    setErrorValidation(_validation)
    return isPass
  }

  const generatePayload = () => {
    const relationships = [...listBundlePrices, ...listDeletedBundlePrices]

    return {relationships}
  }

  const handleSave = () => {
    const isPass = checkValidation()
    if (isPass) {
      const payload = generatePayload()
      onSave(payload)
    }
  }

  useEffect(() => {
    if (prices) {
      const { bundlePrices } = prices
      setListBundlePrices(bundlePrices)
    }
    // eslint-disable-next-line
  }, [prices])


  const renderPrices = (listBundlePrices) => listBundlePrices.map((val, index) => {
    return (
      <Paper shadow="sm" p="lg" key={index} my={15} withBorder style={{ position:'relative' }}>
        <Box style={{ position: 'absolute', right: 0, top: 0 }}>
          {
            listBundlePrices.length > 1 &&
            <ActionIcon variant="transparent" size='lg' color='red' onClick={() => handleRemovePrice(index)}>
              <IconTrash style={{ width: '55%', height: '55%' }} stroke={1.5} />
            </ActionIcon>
          }
        </Box>

        <Box>
          <SimpleGrid cols={3} spacing={'md'} verticalSpacing={'md'}>
            <Select
              size='xs'
              label="Bundle Unit"
              data={[
                { value: 'crt', label: 'CRT' },
                { value: 'lsn', label: 'LSN' },
                { value: 'box', label: 'BOX' },
                { value: 'pak', label: 'PAK' },
                { value: 'set', label: 'SET' },
                { value: 'grs', label: 'GRS' },
              ]}
              value={val.unit_name}
              error={errorValidation[index].unit_name}
              onChange={(val) => handleChange(index, 'unit_name', val)}
            />
            <NumberInput
              size='xs'
              label="Quantity"
              suffix={` ${summary.quantityUnit}`}
              value={val.quantity}
              error={errorValidation[index].quantity}
              onChange={(val) => handleChange(index, 'quantity', val)}
            />
            <NumberInput
              size='xs'
              label="Bundle Price"
              prefix={`${summary.originalCurrency} `}
              value={val.price}
              error={errorValidation[index].price}
              onChange={(val) => handleChange(index, 'price', val)}
            />
          </SimpleGrid>

          <SimpleGrid cols={4} spacing={'md'} verticalSpacing={'md'} mt={10}>
            <NumberInput
              size='xs'
              label="Length"
              suffix={` ${val.dimension_unit}`}
              value={val.dimensions[0].value}
              error={errorValidation[index].length}
              onChange={(val) => handleChangeDimensions(index, 0, val)}
            />
            <NumberInput
              size='xs'
              label="Width"
              suffix={` ${val.dimension_unit}`}
              value={val.dimensions[1].value}
              error={errorValidation[index].width}
              onChange={(val) => handleChangeDimensions(index, 1, val)}
            />
            <NumberInput
              size='xs'
              label="Height"
              suffix={` ${val.dimension_unit}`}
              value={val.dimensions[2].value}
              error={errorValidation[index].height}
              onChange={(val) => handleChangeDimensions(index, 2, val)}
            />
            <NumberInput
              size='xs'
              label="Weight"
              suffix={` ${val.weight_unit}`}
              value={val.weight}
              error={errorValidation[index].weight}
              onChange={(val) => handleChange(index, 'weight', val)}
            />
          </SimpleGrid>

        </Box>
      </Paper>
    )
  })

  return (
    <Box>
      <Group justify="flex-end">
        {listBundlePrices.length <= 2 && <Button size='xs' variant='outline' onClick={() => handleAddPrice()}>+ Add Price</Button>}
      </Group>
      {renderPrices(listBundlePrices)}
      <Group justify="flex-end" mt={10}>
        <Button size='xs' variant='default' onClick={onCloseForm}>Cancel</Button>
        <Button loaderProps={{ type: 'dots' }} disabled={listBundlePrices === 0} loading={loading} size='xs' onClick={() => handleSave()}>Save</Button>
      </Group>
    </Box>
  )
}

export default FormBundlePrice